import { render, staticRenderFns } from "./createDoctor.vue?vue&type=template&id=47c2db30&"
import script from "./createDoctor.vue?vue&type=script&lang=js&"
export * from "./createDoctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports